import React from 'react';
import MoodleAdministration from '../components/MoodleAdministration';

const MoodleAdministrationPage: React.FC = () => {
  return (
    <>
      <MoodleAdministration />
    </>
  );
};

export default MoodleAdministrationPage;